module.exports = __webpack_public_path__ + "static/media/hand-write-text.f006ad27.png";